import { defineMessages } from 'react-intl-next';

export default defineMessages({
	customReportsEmptyStateDescription: {
		id: 'spa-apps-servicedesk-reports-home-page.thumbnail-view.custom-reports-empty-state-description',
		defaultMessage:
			'It looks like you’ve not gained permission to custom reports yet. When your account admin adds you, we’ll list them here.',
		description: 'Empty State description',
	},
	defaultReportsEmptyStateDescription: {
		id: 'spa-apps-servicedesk-reports-home-page.thumbnail-view.default-reports-empty-state-description',
		defaultMessage:
			'It looks like you’ve not gained permission to default reports yet. When your account admin adds you, we’ll list them here.',
		description: 'Empty State description',
	},
	customReportsEmptyStateTitle: {
		id: 'spa-apps-servicedesk-reports-home-page.thumbnail-view.custom-reports-empty-state-title',
		defaultMessage: 'Start creating custom reports',
		description: 'Empty State description',
	},
	defaultReportsEmptyStateTitle: {
		id: 'spa-apps-servicedesk-reports-home-page.thumbnail-view.default-reports-empty-state-title',
		defaultMessage: 'Default reports aren’t available',
		description: 'Empty State description',
	},
});
